import { CalendarClock, Mail, MailCheck, MailOpen, MailX } from 'lucide-react';
import type { ReactNode } from 'react';
import { estadoCorreo, textoProgramado, ultimoEnvio } from '@/lib/correoLiquidacion';
import { classNames } from '@/lib/utils';

/** Sobre según lo que se sabe del correo: enviado, entregado, abierto o no entregado. */
export default function IconoCorreo({ envio, size = 16, className }: { envio: any; size?: number; className?: string }) {
  const { tipo, texto } = estadoCorreo(envio);
  const Icono = tipo === 'abierto' ? MailOpen : tipo === 'entregado' ? MailCheck : tipo === 'no_entregado' ? MailX : Mail;
  const color = tipo === 'abierto' ? 'text-green-600' : tipo === 'entregado' ? 'text-blue-600' : tipo === 'no_entregado' ? 'text-red-600' : 'text-sereno-dark/50';
  return (
    <span title={`${texto}${envio?.para ? ` · ${envio.para}` : ''}`} className={classNames('inline-flex', color, className)}>
      <Icono size={size} aria-label={texto} />
    </span>
  );
}

/** Reloj para un correo programado: azul si está pendiente, rojo si no salió. */
export function IconoProgramado({ programado, size = 16, className }: { programado: any; size?: number; className?: string }) {
  const texto = textoProgramado(programado);
  const color = programado.estado === 'fallido' ? 'text-red-600' : 'text-blue-600';
  return (
    <span title={`${texto}${programado.para ? ` · ${programado.para}` : ''}`} className={classNames('inline-flex', color, className)}>
      <CalendarClock size={size} aria-label={texto} />
    </span>
  );
}

/** Lo que se enseña en el listado: lo programado manda sobre lo ya enviado. */
export function IconoCorreoLiquidacion({ liq, size, vacio }: { liq: any; size?: number; vacio?: ReactNode }) {
  if (liq?.correoProgramado) return <IconoProgramado programado={liq.correoProgramado} size={size} />;
  const envio = ultimoEnvio(liq);
  return envio ? <IconoCorreo envio={envio} size={size} /> : <>{vacio ?? null}</>;
}
